module.exports = __webpack_public_path__ + "dee8f94c0a494267076a13d87dd19b27.jpg";